/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import ReferralWrapper from "./src/ReferralWrapper"
import { navigate } from "gatsby"

import "./src/styles/global.css"
import "react-datepicker/dist/react-datepicker.css"
import "./src/styles/wpbr-public-main.css"
import "./src/styles/custome.css"
import "./src/styles/front-page.css"
import "./src/styles/responsive.css"
import "./src/styles/blog.css"

export const wrapRootElement = ReferralWrapper

export const onRouteUpdate = ({ location }) => {
  // Redirect unknown /app/* paths to the /app index
  const { apps } = require("./src/data/appData")
  const knownAppPaths = ["/app", ...apps.map(a => `/app/${a.slug}`)]
  const normalizedPath = location.pathname.replace(/\/$/, "")
  if (normalizedPath.startsWith("/app") && !knownAppPaths.includes(normalizedPath)) {
    navigate("/app")
    return
  }

  const session = JSON.parse(localStorage.getItem("authFlag"))
  const isValidSession =
    session && session?.valid && new Date().getTime() < session?.expires

  if (process.env.GATSBY_ENVIRONMENT === "DEV") {
    const isAuthenticated =
      typeof window !== "undefined" && localStorage.getItem("authFlag")

    // Gate every page behind the staging login, but never redirect while we're
    // already on /login — doing so re-triggers onRouteUpdate and loops forever
    // (the page visibly "blinks"). login.tsx handles sending an authenticated
    // user off /login back to the site.
    // Compare against normalizedPath, NOT location.pathname: Gatsby 5 defaults to
    // trailingSlash: 'always', so pathname is "/login/" and a bare "/login" check
    // never matches — which is exactly the loop this guard exists to prevent.
    if (normalizedPath !== "/login" && (!isAuthenticated || !isValidSession)) {
      navigate("/login")
    }
  }
}
